"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FilterableCollectionIterator_1 = require("./FilterableCollectionIterator");
const empty = [];
/**
 * Provides a base functionality of a collection that filters itself with given predicates.
 * @abstract
 * @class
 */
class FilterableCollection {
    /**
     * Initializes a new instance of the {@link FilterableCollection<T>} class
     * with initial collections of items to filter.
     * @param {Iterable<T>} [items] Initial collection of items to filter.
     */
    constructor(items) {
        this.filters = {};
        let actualItems = items;
        if (!actualItems || typeof items[Symbol.iterator] !== "function") {
            actualItems = empty;
        }
        this.items = actualItems;
    }
    /**
     * Gets the number of items in this collection.
     * @readonly
     * @returns {number}
     */
    get length() {
        let result = 0;
        const iterator = this[Symbol.iterator]();
        while (!iterator.next().done) {
            result++;
        }
        return result;
    }
    /**
     * Checks whether this collection has any items fitlered.
     * @returns {boolean}
     */
    any() {
        return !this[Symbol.iterator]().next().done;
    }
    /**
     * Gets the first item of the collection or null if there are no items matching the criteria.
     * @returns {T}
     */
    first() {
        const result = this[Symbol.iterator]().next();
        return !result.done ? result.value : null;
    }
    /**
     * Gets the last item of the collection or null if there are no items matching the criteria.
     * @returns {T}
     */
    last() {
        let result = null;
        for (const item of this) {
            result = item;
        }
        return result;
    }
    /**
     * Filters the collection with a generic match evaluator.
     * @param {Function} matchEvaluator Match evaluation delegate.
     * @returns {IFilterableCollection<T>}
     */
    where(matchEvaluator) {
        let result = this;
        if (!!matchEvaluator) {
            const predicate = Object.keys(this.filters)
                .filter(key => key.charAt(0) === "_")
                .map(key => parseInt(key.substr(1), 10))
                .sort()
                .reduce((previousValue, currentValue) => currentValue, 0);
            result = this.narrowFiltersWith("_" + predicate, matchEvaluator);
        }
        return result;
    }
    /**
     * Flattens this collection to a standard array.
     * @returns {T[]}
     */
    toArray() {
        const result = [];
        for (const item of this) {
            result.push(item);
        }
        return result;
    }
    /** @inheritDoc */
    [Symbol.iterator]() {
        return new FilterableCollectionIterator_1.default(this.items, this.filters);
    }
    narrowFiltersWith(predicate, value) {
        const result = this.createInstance(this.items);
        for (const filter of Object.keys(this.filters)) {
            result.filters[filter] = this.filters[filter];
        }
        if (!value) {
            delete result.filters[predicate];
        }
        else {
            result.filters[predicate] = value;
        }
        return result;
    }
}
exports.default = FilterableCollection;
//# sourceMappingURL=FilterableCollection.js.map